import { useMelwaysInfo } from '@seek/melways-react';
import {
  DEFAULT_SUGGESTION_COUNT,
  RoleTitleFilter,
  type Market,
} from '@ts-internal/shared-lib';

import { useGetSuggestionsForRoleTitleLazyQuery } from 'src/graphql/Queries/getSuggestionsForRoleTitle.generated';

type Props = Omit<
  Parameters<typeof RoleTitleFilter>[0],
  'suggestions' | 'onDebouncedSearchTextChange' | 'onSearchTextChange'
> & {
  selectedMarket: Market;
};

export const CandidateRoleTitleFilter = ({
  selectedMarket,
  ...props
}: Props) => {
  const { language } = useMelwaysInfo();

  const [triggerGetSuggestions, { data }] =
    useGetSuggestionsForRoleTitleLazyQuery({
      // See context in previous implementation re duplicate ids, so avoid cache
      fetchPolicy: 'no-cache',
    });

  const suggestions = (data?.ontologyRoleTitlesSeniority || []).map(
    ({ id, normalisedText }) => ({
      id,
      name: normalisedText,
    }),
  );

  const handleSearchTextChange = (newSearchText: string) => {
    if (newSearchText) {
      triggerGetSuggestions({
        variables: {
          query: newSearchText,
          count: DEFAULT_SUGGESTION_COUNT,
          countryCode: selectedMarket,
          languageCode: language,
          session: '',
        },
      });
    }
  };

  return (
    <RoleTitleFilter
      {...props}
      suggestions={suggestions}
      onDebouncedSearchTextChange={handleSearchTextChange}
    />
  );
};
